function ProductItem(props) {

    const { id, name, price, count, incrCount, decrCount, delProduct } = props

    return (
        <div>
            <div key={id} className='product-item'>
                <div onDoubleClick={() => delProduct(id)}>
                    <h1>{name}</h1>
                    <h2>{price}</h2>
                </div>
                <div style={{ display: 'ruby'}}>
                    <button style={{fontSize: '17px'}} onClick={() => decrCount(id)}>-</button>
                    <p>{count}</p>
                    <button style={{fontSize: '17px'}} onClick={() => incrCount(id)}>+</button>
                </div>
            </div>
        </div>
    )
}

export default ProductItem